module.exports = __webpack_public_path__ + "media/images/emblems/Mirchel-coat_of_arms-2ff522ddc7601f4bd4ded1a4dc259daf.svg";